import { PropsWithChildren } from "react";

import { FilterBar, Item } from "@bps/fluent-ui";

export interface RolloutPackageDesiredConfigFilterValues {
  name: string;
}

interface RolloutPackageDesiredConfigFilterProps
  extends PropsWithChildren<any> {}

export const RolloutPackageDesiredConfigFilter = ({
  children
}: RolloutPackageDesiredConfigFilterProps) => {
  const filterItems: Item<RolloutPackageDesiredConfigFilterValues>[] = [
    {
      name: "name",
      type: "searchBox",
      stickItem: true,
      props: { placeholder: "Search by name", removeSpecialCharacters: false }
    }
  ];

  return (
    <FilterBar<RolloutPackageDesiredConfigFilterValues>
      items={filterItems}
      initialValues={{
        name: ""
      }}
    >
      {children}
    </FilterBar>
  );
};
